export const getDay = (checkInDate?: Date | null, checkOutDate?: Date | null) => {
    if (checkInDate && checkOutDate) {
        return Math.floor((checkOutDate.getTime() - checkInDate.getTime()) / (1000 * 60 * 60 * 24) + 1);
    }
    return 0;
};
